import React, { useState } from "react";
import "../Admin/AdminUse.css";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const [activeMenu, setActiveMenu] = useState([]); // Track active menus htmlFor tree view

  const menuItems = [
    {
      title: "Home",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.75 9.75V17.25H11.25V12.75H6.75V17.25H2.25V9.75H0L9 0.75L18 9.75H15.75ZM15 5.31975V1.5H12.75V3.06975L15 5.31975Z"
            fill="#6F757E"
          />
        </svg>
      ),
      subMenu: [
        {
          title: "Dashboard",
          link: "/admin/dashboard",
        },
        {
          title: "Sales",
          link: "/admin/sales",
        },
      ],
    },
    {
      title: "Admin",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.7486 6.37354H2.25161C1.82486 6.37354 1.50086 6.72153 1.50086 7.12278C1.50086 7.21128 1.42211 6.68629 2.77136 15.117C2.82911 15.4815 3.14336 15.7485 3.51236 15.7485H14.4886C14.8576 15.7485 15.1719 15.4815 15.2296 15.117C16.5804 6.67954 16.4994 7.21204 16.4994 7.12204C16.4994 6.70354 16.1574 6.37354 15.7486 6.37354ZM15.0256 4.11079H3.00311C2.61011 4.11079 2.25236 4.42729 2.25236 4.86604C2.25236 4.92679 2.24486 4.87804 2.35736 5.62354H15.6714C15.7854 4.86454 15.7756 4.92529 15.7756 4.86679C15.7756 4.43179 15.4239 4.11079 15.0256 4.11079Z"
            fill="#6F757E"
          />
        </svg>
      ),
      subMenu: [
        {
          title: "Users",
          link: "#",
          subMenu: [
            { title: "All Users", link: "/admin/allusers" },
            { title: "Add User", link: "/admin/adduser" },
          ],
        },
        {
          title: "Utilities",
          link: "#",
          subMenu: [
            { title: "Utilities", link: "/admin/addUtilities" },
          ],
        },
      ],
    },
    {
      title: "Ecommerce",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clipPath="url(#clip0_953_1912)">
            <path
              d="M3.4185 5.25L6.94425 1.7235C7.0935 1.575 7.28925 1.5 7.485 1.5C7.94475 1.5 8.25 1.87875 8.25 2.27175C8.25 2.45925 8.181 2.64975 8.02575 2.805L5.58075 5.25H3.4185ZM12.4193 5.25H14.5815L11.0557 1.7235C10.9065 1.575 10.7108 1.5 10.515 1.5C10.0553 1.5 9.75 1.87875 9.75 2.27175C9.75 2.45925 9.819 2.64975 9.97425 2.805L12.4193 5.25ZM0 6.75V8.25H0.48225C0.88275 8.25 1.248 8.478 1.42425 8.838L4.5 16.5H13.5L16.5765 8.8395C16.7512 8.47875 17.118 8.25 17.5185 8.25H18V6.75H0Z"
              fill="#6F757E"
            />
          </g>
          <defs>
            <clipPath id="clip0_953_1912">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      subMenu: [
        {
          title: "Products",
          link: "#",
          subMenu: [
            { title: "All Products", link: "/admin/allProduct" },
            // { title: "Edit Product", link: "/admin/edit-products" },
            { title: "All Categories", link: "/admin/allCategory" },
            { title: "New Addition", link: "/admin/addProduct" },
          ],
        },
        // {
        //   title: "Orders",
        //   link: "#",
        //   subMenu: [
        //     { title: "Order List", link: "/admin/demo" },
        //     { title: "Order Detail", link: "/admin/order-detail" },
        //   ],
        // },
      ],
    },
  ];

  const toggleSubMenu = (path) => {
    setActiveMenu((prevMenu) =>
      prevMenu.includes(path)
        ? prevMenu.filter((item) => item !== path)
        : [...prevMenu, path]
    );
  };

  const renderMenuItems = (items, parentPath = "") => {
    return items.map((item, index) => {
      const currentPath = parentPath
        ? `${parentPath}.${item.title}`
        : item.title;
      const isActive = activeMenu.includes(currentPath);
      const hasSubMenu = item.subMenu && item.subMenu.length > 0;

      return (
        <div key={index} className={`menu-item ${isActive ? "active" : ""}`}>
          <div
            className="menu-title"
            onClick={() => hasSubMenu && toggleSubMenu(currentPath)}
          >
            <span>
              {item.icon}{" "}
              {item.link ? (
                <Link to={item.link}>{item.title}</Link>
              ) : (
                item.title
              )}
            </span>
            {hasSubMenu && (
              <i
                className={`fas fa-angle-right dropdown-icon ${
                  isActive ? "rotate" : ""
                }`}
              ></i>
            )}
          </div>
          {hasSubMenu && isActive && (
            <div className="submenu" style={{ paddingLeft: "20px" }}>
              {renderMenuItems(item.subMenu, currentPath)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <img src="/images/logo.png" alt="Sidebar Logo" />
      </div>
      <div className="menu">{renderMenuItems(menuItems)}</div>
    </div>
  );
};

export default Sidebar;
